import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import * as constants from '../../common/constants/constants'
import { integrationsList } from './d';

interface Integration {
  image: string;
  complete: boolean;
  title: string;
  description: string;
}

interface State {
  integrationsData: Integration[];
  currentScreen: string;
  currentAuthStep: string;
  selectedItem: Integration | null;
}

const integrationsData = [...integrationsList];

export default {
  state: {
    integrationsData,
    currentScreen: constants.INTEGRATIONS,
    currentAuthStep: constants.AUTH_INIT,
    selectedItem: null,
  },
  getters: {
    [getters.GET_BUILDER_INTEGRATIONS_DATA]({ integrationsData }) {
      return integrationsData
    },
    [getters.SELECTED_INTEGRATION]({ selectedItem }) {
      return selectedItem
    },
    [getters.GET_INTEGRATIONS_CURRENT_SCREEN]({ currentScreen }) {
      return currentScreen
    },
    [getters.GET_INTEGRATIONS_AUTH_STEP]({ currentAuthStep }) {
      return currentAuthStep
    },
  },
  mutations: {
    [mutations.SELECT_INTEGRATION](state, selectedItem) {
      state.selectedItem = selectedItem
      state.currentScreen = constants.AUTHENTICATE
      state.currentAuthStep = constants.AUTH_INIT
    },
    [mutations.UPDATE_INTEGRATIONS_CURRENT_SCREEN](state, screen) {
      state.currentScreen = screen
    },
    [mutations.UPDATE_INTEGRATIONS_AUTH_STEP](state, step) {
      state.currentAuthStep = step
    },
  },
  actions: {
    [actions.UPDATE_BUILDER_INTEGRATIONS_DATA]({ commit, state }, data) {
      return state.integrationsData = data;
    },
    [actions.SELECT_INTEGRATION]({ commit, state }, selectedItem) {
      commit(mutations.SELECT_INTEGRATION, selectedItem)
    },
    [actions.UPDATE_INTEGRATIONS_CURRENT_SCREEN]({ commit, state }, screen) {
      commit(mutations.UPDATE_INTEGRATIONS_CURRENT_SCREEN, screen)
    },
    [actions.UPDATE_INTEGRATIONS_AUTH_STEP]({ commit, state }, step) {
      commit(mutations.UPDATE_INTEGRATIONS_AUTH_STEP, step)
    },
  },
}